'use client';
import * as React from 'react';
import useScreenHeight from '../hooks/useScreenHeight';
import { useEffect } from 'react';

export default function DynamicCSS(props) {
    const screenHeight = useScreenHeight();

    useEffect(() => {
        // Update the --vh variable on the body tag
        document.body.style.setProperty('--vh', `${screenHeight}px`);
    }, [screenHeight]);

    // return <div style={{ '--vh': screenHeight + 'px' }}>{props.children}</div>;
    return <>{props.children}</>;
}
